import { GlobalStateContext } from '../App';
import DimensionsSvg from '../Components/images/dimensions.svg';
import ZoomIn from '../Components/images/zoom-in.svg';
import ZoomOut from '../Components/images/zoom-out.svg';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

export const ClickableIcons = ({ dimensionsClicked, mobile }) => {
  const { setGlobalStateItem } = useContext(GlobalStateContext);

  const zoomInFactor= .9
  const zoomOutFactor= 1/zoomInFactor

  const zoomInClicked = () => {
			setGlobalStateItem('zoom', zoomInFactor + Math.random() * 0.001); // add random to trigger useEffect
	}

	const zoomOutClicked = () => {
			setGlobalStateItem('zoom', zoomOutFactor + Math.random() * 0.001);
	}

  return (
    <div className="clickable-icons">
      <Link onClick={dimensionsClicked} className="dimensions-icon">
        <img src={DimensionsSvg} alt="dimensions" />
      </Link>
      {!mobile && (
        <>
          <Link onClick={zoomInClicked} className="zoom-in-icon">
            <img src={ZoomIn} alt="Zoom In" />
          </Link>
          <Link onClick={zoomOutClicked} className="zoom-out-icon">
            <img src={ZoomOut} alt="Zoom Out" />
          </Link>
        </>
      )}
    </div>
  );
};

export default ClickableIcons;
